export default __webpack_public_path__ + "static/media/db.32cae1cf.png";